import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
import { NumberFormatter } from "@internationalized/number";
import { MessageDictionary, MessageFormatter } from "@internationalized/message";
import { useIsSSR } from "@react-aria/ssr";
import _react, { useEffect, useState, useContext, useCallback, useMemo } from "react";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// https://en.wikipedia.org/wiki/Right-to-left

var $d26e725ad56fbcb2c25f52b7de27$var$RTL_SCRIPTS = new Set(['Arab', 'Syrc', 'Samr', 'Mand', 'Thaa', 'Mend', 'Nkoo', 'Adlm', 'Rohg', 'Hebr']);
var $d26e725ad56fbcb2c25f52b7de27$var$RTL_LANGS = new Set(['ae', 'ar', 'arc', 'bcc', 'bqi', 'ckb', 'dv', 'fa', 'glk', 'he', 'ku', 'mzn', 'nqo', 'pnb', 'ps', 'sd', 'ug', 'ur', 'yi']);
/**
 * Determines if a locale is read right to left using [Intl.Locale]{@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale}.
 */

function $d26e725ad56fbcb2c25f52b7de27$export$isRTL(locale) {
  // If the Intl.Locale API is available, use it to get the script for the locale.
  // This is more accurate than guessing by language, since languages can be written in multiple scripts.
  // @ts-ignore
  if (Intl.Locale) {
    // @ts-ignore
    var script = new Intl.Locale(locale).maximize().script;
    return $d26e725ad56fbcb2c25f52b7de27$var$RTL_SCRIPTS.has(script);
  } // If not, just guess by the language (first part of the locale)


  var lang = locale.split('-')[0];
  return $d26e725ad56fbcb2c25f52b7de27$var$RTL_LANGS.has(lang);
}
/**
 * Gets the locale setting of the browser.
 */


function $e851d0b81d46abd5f971c8e95c27f1$export$getDefaultLocale() {
  // @ts-ignore
  var locale = typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage) || 'en-US';
  return {
    locale: locale,
    direction: $d26e725ad56fbcb2c25f52b7de27$export$isRTL(locale) ? 'rtl' : 'ltr'
  };
}

var $e851d0b81d46abd5f971c8e95c27f1$var$currentLocale = $e851d0b81d46abd5f971c8e95c27f1$export$getDefaultLocale();
var $e851d0b81d46abd5f971c8e95c27f1$var$listeners = new Set();

function $e851d0b81d46abd5f971c8e95c27f1$var$updateLocale() {
  $e851d0b81d46abd5f971c8e95c27f1$var$currentLocale = $e851d0b81d46abd5f971c8e95c27f1$export$getDefaultLocale();

  var _iterator = _createForOfIteratorHelper($e851d0b81d46abd5f971c8e95c27f1$var$listeners),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var listener = _step.value;
      listener($e851d0b81d46abd5f971c8e95c27f1$var$currentLocale);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
/**
 * Returns the current browser/system language, and updates when it changes.
 */


function $e851d0b81d46abd5f971c8e95c27f1$export$useDefaultLocale() {
  var isSSR = useIsSSR();

  var _useState = useState($e851d0b81d46abd5f971c8e95c27f1$var$currentLocale),
      _useState2 = _slicedToArray(_useState, 2),
      defaultLocale = _useState2[0],
      setDefaultLocale = _useState2[1];

  useEffect(function () {
    if ($e851d0b81d46abd5f971c8e95c27f1$var$listeners.size === 0) {
      window.addEventListener('languagechange', $e851d0b81d46abd5f971c8e95c27f1$var$updateLocale);
    }

    $e851d0b81d46abd5f971c8e95c27f1$var$listeners.add(setDefaultLocale);
    return function () {
      $e851d0b81d46abd5f971c8e95c27f1$var$listeners.delete(setDefaultLocale);

      if ($e851d0b81d46abd5f971c8e95c27f1$var$listeners.size === 0) {
        window.removeEventListener('languagechange', $e851d0b81d46abd5f971c8e95c27f1$var$updateLocale);
      }
    };
  }, []); // We cannot determine the browser's language on the server, so default to
  // en-US. This will be updated after hydration on the client to the correct value.

  if (isSSR) {
    return {
      locale: 'en-US',
      direction: 'ltr'
    };
  }

  return defaultLocale;
}

var $cff8541df3b5c83067b2ab3ee0d20$var$I18nContext = /*#__PURE__*/_react.createContext(null);

export function I18nProvider(props) {
  var locale = props.locale,
      children = props.children;
  var defaultLocale = $e851d0b81d46abd5f971c8e95c27f1$export$useDefaultLocale();
  var value = locale ? {
    locale: locale,
    direction: $d26e725ad56fbcb2c25f52b7de27$export$isRTL(locale) ? 'rtl' : 'ltr'
  } : defaultLocale;
  return /*#__PURE__*/_react.createElement($cff8541df3b5c83067b2ab3ee0d20$var$I18nContext.Provider, {
    value: value
  }, children);
}
/**
 * Returns the current locale and layout direction.
 */

export function useLocale() {
  var defaultLocale = $e851d0b81d46abd5f971c8e95c27f1$export$useDefaultLocale();
  var context = useContext($cff8541df3b5c83067b2ab3ee0d20$var$I18nContext);
  return context || defaultLocale;
}
var $f58d206cee90f9c2bf3c03e4522c35$var$cache = new WeakMap();

function $f58d206cee90f9c2bf3c03e4522c35$var$getCachedDictionary(strings) {
  var dictionary = $f58d206cee90f9c2bf3c03e4522c35$var$cache.get(strings);

  if (!dictionary) {
    dictionary = new MessageDictionary(strings);
    $f58d206cee90f9c2bf3c03e4522c35$var$cache.set(strings, dictionary);
  }

  return dictionary;
}
/**
 * Handles formatting ICU Message strings to create localized strings for the current locale.
 * Automatically updates when the locale changes, and handles caching of messages for performance.
 * @param strings - A mapping of languages to strings by key.
 */


export function useMessageFormatter(strings) {
  var _useLocale = useLocale(),
      locale = _useLocale.locale;

  var dictionary = useMemo(function () {
    return $f58d206cee90f9c2bf3c03e4522c35$var$getCachedDictionary(strings);
  }, [strings]);
  var formatter = useMemo(function () {
    return new MessageFormatter(locale, dictionary);
  }, [locale, dictionary]);
  return useCallback(function (key, variables) {
    return formatter.format(key, variables);
  }, [formatter]);
}
var $b0007c63a64054c318efb8b6cd0053f$var$formatterCache = new Map();
/**
 * Provides localized date formatting for the current locale. Automatically updates when the locale changes,
 * and handles caching of the date formatter for performance.
 * @param options - Formatting options.
 */

export function useDateFormatter(options) {
  var _useLocale2 = useLocale(),
      locale = _useLocale2.locale; // Polyfill the `calendar` option - not supported in Safari.


  if (options != null && options.calendar && !locale.includes('-u-ca-')) {
    locale += '-u-ca-' + options.calendar;
  }

  var cacheKey = locale + (options ? Object.entries(options).sort(function (a, b) {
    return a[0] < b[0] ? -1 : 1;
  }).join() : '');

  if ($b0007c63a64054c318efb8b6cd0053f$var$formatterCache.has(cacheKey)) {
    return $b0007c63a64054c318efb8b6cd0053f$var$formatterCache.get(cacheKey);
  }

  var formatter = new Intl.DateTimeFormat(locale, options);
  $b0007c63a64054c318efb8b6cd0053f$var$formatterCache.set(cacheKey, formatter);
  return formatter;
}
/**
 * Provides localized number formatting for the current locale. Automatically updates when the locale changes,
 * and handles caching of the number formatter for performance.
 * @param options - Formatting options.
 */

export function useNumberFormatter(options) {
  if (options === void 0) {
    options = {};
  }

  var _useLocale3 = useLocale(),
      locale = _useLocale3.locale;

  return useMemo(function () {
    return new NumberFormatter(locale, options);
  }, [locale, options]);
}
var $a4045a18d7252bf6de9312e613c4e$var$cache = new Map();
/**
 * Provides localized string collation for the current locale. Automatically updates when the locale changes,
 * and handles caching of the collator for performance.
 * @param options - Collator options.
 */

export function useCollator(options) {
  var _useLocale4 = useLocale(),
      locale = _useLocale4.locale;

  var cacheKey = locale + (options ? Object.entries(options).sort(function (a, b) {
    return a[0] < b[0] ? -1 : 1;
  }).join() : '');

  if ($a4045a18d7252bf6de9312e613c4e$var$cache.has(cacheKey)) {
    return $a4045a18d7252bf6de9312e613c4e$var$cache.get(cacheKey);
  }

  var formatter = new Intl.Collator(locale, options);
  $a4045a18d7252bf6de9312e613c4e$var$cache.set(cacheKey, formatter);
  return formatter;
}
/**
 * Provides localized string search functionality that is useful for filtering or matching items
 * in a list. Options can be provided to adjust the sensitivity to case, diacritics, and other parameters.
 */

export function useFilter(options) {
  var collator = useCollator(_babelRuntimeHelpersEsmExtends({
    usage: 'search'
  }, options)); // TODO(later): these methods don't currently support the ignorePunctuation option.

  return {
    startsWith: function startsWith(string, substring) {
      if (substring.length === 0) {
        return true;
      } // Normalize both strings so we can slice safely
      // TODO: take into account the ignorePunctuation option as well...


      string = string.normalize('NFC');
      substring = substring.normalize('NFC');
      return collator.compare(string.slice(0, substring.length), substring) === 0;
    },
    endsWith: function endsWith(string, substring) {
      if (substring.length === 0) {
        return true;
      }

      string = string.normalize('NFC');
      substring = substring.normalize('NFC');
      return collator.compare(string.slice(-substring.length), substring) === 0;
    },
    contains: function contains(string, substring) {
      if (substring.length === 0) {
        return true;
      }

      string = string.normalize('NFC');
      substring = substring.normalize('NFC');
      var scan = 0;
      var sliceLen = substring.length;

      for (; scan + sliceLen <= string.length; scan++) {
        var slice = string.slice(scan, scan + sliceLen);

        if (collator.compare(substring, slice) === 0) {
          return true;
        }
      }

      return false;
    }
  };
}